module.exports = __webpack_public_path__ + "img/ctrl-qft-stub-up-+i.b0124aed.svg";